import aarhusguidenEventPage from "../modules/third-party/aarhusguiden/aarhusguiden-event-page";
import aarhusguidenFilter from "../modules/third-party/aarhusguiden/aarhusguiden-filter";
import aarhusguidenList from "../modules/third-party/aarhusguiden/aarhusguiden-list"

document.addEventListener('DOMContentLoaded', function() {
    aarhusguidenList();
    aarhusguidenEventPage();
    aarhusguidenFilter();
})